<template>
  <div id="start-menu">

    <div
      class="columns is-multiline is-centered is-mobile mx-0 buttonsStartContainer"
      style="width: 100%"
    >
      <div class="column is-12" v-if="params.menuDigitalForm == 1">
        <div
          @click="formOrMenu(2, 'menu-start-registro')"
          class="
            btn-card-mobile
            mx-auto
            is-flex
            is-flex-direction-row
            is-justify-content-center
            is-align-items-center
            no-background
          "
          :style="{
            'background-image': gradient() + 'url()',
          }"
        >
          <div class="card-img-size">
            <img
              alt
              class="card-img-size"
              src="@/assets/images/icons/resgistro.svg"
            />
          </div>
          <div class="line-divider"></div>
          <span class="title-text-menu">Registro</span>
        </div>
      </div>
      <div
        class="column is-12"
        v-if="params.menuDigitalForm == 1 && offices.length > 0"
      >
        <div
          @click="formOrMenu(9, 'menu-start-encuesta')"
          class="
            btn-card-mobile
            is-flex
            is-flex-direction-row
            no-background
            botonesMenuStart
          "
          :style="{ 'background-image': gradient() + backgroundEncuesta }"
        >

          <span class="title-text-menu">Encuestas de Satisfacción</span>
                    <div class="card-img-size">
            <img
              alt
              class="card-img-size"
              src="@/assets/images/icons/encuesta-de-satisfaccion.svg"
            />
          </div>
        </div>
      </div>
      <div
        class="column is-12"
        v-if="params.menuDigitalCarta == 1 && params.multiMenu == 0"
      >
        <div
          @click="formOrMenu(4, 'menu-start-menu')"
          class="
            btn-card-mobile
            is-flex
            is-flex-direction-row
            no-background
            botonesMenuStart
          "
          :style="{
            'background-image': gradient() + 'url()',
          }"
        >

          <span class="title-text-menu">Menú</span>
                    <div class="card-img-size">
            <img
              alt
              class="card-img-size"
              src="@/assets/images/icons/menu.svg"
            />
          </div>
        </div>
      </div>
      <div
        class="column is-12"
        v-if="params.menuDigitalCarta == 1 && params.multiMenu == 1"
      >
        <div
          @click="formOrMenu(6, 'menu-start-menu')"
          class="
            btn-card-mobile
            is-flex
            is-flex-direction-row
            no-background
            botonesMenuStart
          "
          :style="{
            'background-image': gradient() + 'url()',
          }"
        >

          <span class="title-text-menu">Menú</span>
                    <div class="card-img-size ">
                      <img
              alt
              class="card-img-size imgMenu"
              src="@/assets/images/icons/menu.svg"
            />
            </div>

        </div>
      </div>
      <div
        :key="index + 'item.name'"
        class="column is-12"
        v-for="(item, index) in options"
      >
        <div
          @click="openLink(item.items, item)"
          class="
            btn-card-mobile
            is-flex
            is-flex-direction-row
                        no-background
            botonesMenuStart
          "
          :class="{'no-background': item.background === null }"
          :style="{
            'background-image': gradient() + 'url(' + item.background + ')',
          }"
        >
                  <span class="title-text-menu">{{ item.title }}</span>
          <div class="card-img-size">
            <img
              :src="item.image"
              alt
              class="card-img-size"
              v-if="item.image"
            />
            <img
              alt
              class="card-img-size"
              src="@/assets/images/icons/encuesta-de-satisfaccion.svg"
              v-else-if="item.title.toLowerCase() == 'encuesta de satisfacción'"
            />
            <img
              alt
              class="card-img-size"
              src="@/assets/images/icons/pago-sin-contacto.svg"
              v-else-if="item.title.toLowerCase() == 'pago sin contacto'"
            />
            <img
              alt
              class="card-img-size"
              src="@/assets/images/icons/resrevas.svg"
              v-else-if="item.title.toLowerCase() == 'reservar'"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import whiteLabelTypes from '@/store/types/whiteLabel';
import globalTypes from '@/store/types/global';
import { metrics } from '@/helpers/apis/metrics.js';

export default {
  data () {
    return {
      options: null,
      offices: [],
      backgroundMenu: `url(${require('../../assets/images/menuDigital/menu-background.png')})`,
      backgroundEncuesta: `url(${require('../../assets/images/menuDigital/encuesta-background.png')})`
    };
  },
  mounted () {
    this.getOptions();
    this.getOffices();
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', 'Menu Parametrizable');
    }
  },
  methods: {
    formOrMenu (num, option) {
      metrics(option);
      if (num === 2) {
        this.$emit('activeView', 2);
      } else {
        if (this.params.multiMenu) {
          this.$emit('activeView', 6);
        } else {
          this.$emit('activeView', 4);
        }
      }
      if (num === 9) {
        this.$emit('activeView', 9);
      }
    },
    openLink (item, data) {
      metrics('menu-start-link-' + data.title, 'spanish', data.id);
      if (item[0].type === 'url') {
        window.open(item[0].image);
      } else if (item[0].type === 'image') {
        this.$emit('activeView', 5);
        this.$emit('image', item);
      }
    },
    getOptions () {
      this.$http
        .get('menudigital/param/' + this.params.vendorId)
        .then(({ data }) => {
          this.options = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOffices () {
      this.$store
        .dispatch({ type: 'whiteLabel:branch', data: { url: this.vendorUrl } })
        .then((response) => {
          this.offices = response;
        })
        .catch(() => {
          console.log('Error al cargar Branch');
        });
    }
  },
  computed: {
    ...mapGetters({
      vendorUrl: globalTypes.getters.vendorUrl,
      branch: whiteLabelTypes.getters.branch
    })
  }
};
</script>
<style lang="scss">
@import "@/assets/styles/MenuDigital/components/start.scss";
</style>
